import React from "react";
import { Typography } from "@mui/material";
import { appVersion } from "../../App";
import { NORLYS } from "../../utility/TextLabels";

const Footer: React.FC = () => {
  const footerStyle: React.CSSProperties = {
    position: "fixed",
    bottom: 0,
    width: "100%",
    padding: "10px 0",
    textAlign: "center",
  };

  return (
    <footer style={footerStyle}>
      <Typography variant="body2" color="textSecondary" align="center">
        © {new Date().getFullYear()} {NORLYS}
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        Version: {appVersion}
      </Typography>
    </footer>
  );
};

export default Footer;
